export const SEND_TOKEN = "SEND_TOKEN";
export const CLEAN_TOKEN = "CLEAN_TOKEN";